export default "__VITE_ASSET__CPMd_hiy__"